import editableValueUrl from './editableValue.html';
import editableMoneyValueUrl from './editableMoneyValue.html';
import editableNumberValueUrl from './editableNumberValue.html';

const ESC_KEY_CODE = 27;

class EditableValueCtrl {
  constructor(focus, uuid, Utils, $rootScope, $document) {
    'ngInject';

    Object.assign(this, { focus, uuid, Utils, $rootScope, $document });
  }

  $onInit() {
    this.newValue = this.value;
    this.showEditOption = false;
    this.currencySymbol = this.$rootScope.currencySymbol;
    this.placeholder = this.editPlaceholder || 'Edit wage';
    this.fieldType = this.type || 'money';
    this.editableMoneyValueUrl = editableMoneyValueUrl;
    this.editableNumberValueUrl = editableNumberValueUrl;
    this.id = this.uuid.new();
    this.numberWithDecimalPattern = this.Utils.getNumberValidationPattern();
    this.numberPattern = this.allowIntegerOnly ? /^[0-9]*$/ : this.numberWithDecimalPattern;
    this.listener = this.$rootScope.$on('edit-value-triggered', (e, id) => {
      if (this.isEditActive && id !== this.id) {
        this.saveValue();
      }
    });
  }

  saveValue = () => {
    if (this.form.$valid) {
      this.submitValue();
      this.cancelEditMode();
      this.showEditOption = false;
    }
  };

  $onChanges({ cancelCounter, saveCounter, value }) {
    if (cancelCounter && !cancelCounter.isFirstChange()) {
      this.cancelEditMode();
      this.showEditOption = false;
      this.newValue = this.value;
    }

    if (this.isEditActive && saveCounter && !saveCounter.isFirstChange()) {
      this.saveValue();
    }

    if (value && !value.isFirstChange()) {
      this.newValue = value.currentValue;
    }
  }

  $onDestroy() {
    this.listener();
    this.$document.off('click', this.clickListener);
  }

  clickListener = (event) => {
    if (this.isEditActive && event.target.id !== `editable-value-${this.id}`) {
      this.saveValue();
    }
  };

  mouseOver() {
    this.showEditOption = true;
  }

  mouseLeave() {
    if (!this.isEditActive) {
      this.showEditOption = false;
    }
  }

  inputKeydown(event) {
    if (event.keyCode === ESC_KEY_CODE && this.isEditActive) {
      this.cancelEditMode();
    }
  }

  isMoneyType() {
    return this.fieldType === 'money';
  }

  isNumberType() {
    return this.fieldType === 'number';
  }

  isNumber(value) {
    return (
      (typeof value === 'number' || typeof value === 'string') &&
      value !== '' &&
      !Number.isNaN(Number(value))
    );
  }

  cancelEditMode() {
    this.isEditActive = false;
    this.$document.off('click', this.clickListener);
  }

  startEditMode($event) {
    $event.stopPropagation();

    this.isEditActive = true;
    this.focus(`focus-${this.id}`);
    this.form.$setDirty();
    this.$rootScope.$emit('edit-value-triggered', this.id);
    this.$document.on('click', this.clickListener);
  }

  submitValue() {
    const payload = { value: this.newValue };

    if (this.positionId) {
      payload.positionId = this.positionId;
    }

    if (this.locationId) {
      payload.locationId = this.locationId;
    }

    this.onSubmit(payload);
  }
}

export default {
  templateUrl: editableValueUrl,
  controller: EditableValueCtrl,
  controllerAs: 'ctrl',
  bindings: {
    value: '<',
    emptyLabel: '<',
    positionId: '<?',
    locationId: '<?',
    editPlaceholder: '@?',
    type: '@?',
    allowIntegerOnly: '<',
    onSubmit: '&',
    cancelCounter: '<',
    saveCounter: '<',
  },
};
